import React from "react";

const AdvanceViewerIframe = (props) => {
  return (
    <div
      className="iframeContainer"
      style={{
        textAlign: "center",
      }}
    >
      <iframe
        src={props.advanceViewerUrl}
        allow="clipboard-read; clipboard-write; fullscreen"
        style={{
          border: "0px",
          width: "100%",
          height: "100%",
        }}
      ></iframe>{" "}
    </div>
  );
};

export default AdvanceViewerIframe;
